/**
 * Signals that a component is rendered inside a ProseMirror contenteditable.
 *
 * ProseMirror uses a MutationObserver to track DOM changes inside its editor.
 * Some foundations-components behaviors (e.g. floating-ui's FloatingPortal
 * injecting focus-guard DOM nodes to preserve tab order) cause mutations that
 * ProseMirror interprets as content changes, destroying and recreating
 * NodeViews. This context lets components like Popover detect when they're
 * inside ProseMirror and suppress those mutations.
 *
 * Provided by hubspot-prosemirror's ReactNodeViewPortalsProvider.
 */

import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ProsemirrorContext = /*#__PURE__*/createContext(false);
export const ProsemirrorContextProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsx(ProsemirrorContext.Provider, {
    value: true,
    children: children
  });
};
export const useIsInsideProsemirror = () => useContext(ProsemirrorContext);